// extracted by mini-css-extract-plugin
module.exports = {"main__title":"SecondStep_main__title__1-UBN","main__table":"SecondStep_main__table__1HAXN","main":"SecondStep_main__2Vz7q"};